export const ruMessages = {
  "common.loading": "Загрузка...",
  "common.error": "Ошибка",
  "common.back": "Назад",
  "common.next": "Далее",
  "common.search": "Поиск",
  "auth.loginErrorTitle": "Ошибка входа",
  "auth.openViaTelegram": "Откройте приложение через Telegram",
  "auth.telegramRequired": "Приложение должно быть открыто через Telegram",
  "auth.authorizationError": "Ошибка авторизации",
  "device.rotatePortrait": "Поверните устройство вертикально",
  "country.brazil": "Бразилия",
  "country.vietnam": "Вьетнам",
  "country.egypt": "Египет",
  "country.india": "Индия",
  "country.indonesia": "Индонезия",
  "country.iran": "Иран",
  "country.spain": "Испания",
  "country.italy": "Италия",
  "country.kazakhstan": "Казахстан",
  "country.colombia": "Колумбия",
  "country.malaysia": "Малайзия",
  "country.mexico": "Мексика",
  "country.nigeria": "Нигерия",
  "country.pakistan": "Пакистан",
  "country.russia": "Россия",
  "country.usa": "США",
  "country.turkey": "Турция",
  "country.uzbekistan": "Узбекистан",
  "country.ukraine": "Украина",
  "country.philippines": "Филиппины",
  "countrySelection.chooseCountry": "Выберите страну",
  "countrySelection.openAria": "Выбрать страну",
  "languageSelection.chooseLanguage": "Выберите язык",
  "commercial.direction.autotrade": "Автоторг",
  "commercial.direction.insurance": "Страховка",
  "commercial.direction.pitstop": "Пит-стоп",
  "commercial.direction.techhelp": "Техпомощь",
  "commercial.searchLabel": "Поиск BeepApp",
  "commercial.cityPlaceholder": "Введите город",
  "commercial.emptyTitle": "Сегодня предложений нет",
  "commercial.emptyLine1": "В вашем городе пока нет активных партнёров BeepApp",
  "commercial.emptyLine2": "Мы уже работаем над их поиском и подключением",
  "commercial.emptyLine3": "Новые предложения появятся здесь автоматически",
  "commercial.helperLine1": "Укажите город, чтобы посмотреть",
  "commercial.helperLine2": "доступные предложения",
  "commercial.partnerPrompt": "Хотите стать партнёром BeepApp?",
  "commercial.apply": "Подать заявку",
  "main.admin": "Админ",
  "main.garage": "Гараж",
  "main.signalSent": "Сигнал отправлен",
  "main.partnerInviteUnavailable": "Партнёрское приглашение недоступно",
  "main.enterPlate": "Введите госномер",
  "main.searchError": "Ошибка поиска",
  "main.signalSendError": "Ошибка отправки сигнала",
  "main.shareCardPrefix": "Карточка номера",
  "main.shareLinkError": "Не удалось подготовить ссылку",
  "main.searchByPlateAria": "Поиск по госномеру",
  "main.russianPlateAria": "Российский госномер",
  "main.plateAria": "Госномер",
  "main.findPlateAria": "Найти номер",
  "main.loadingVehicle": "Загружаем карточку номера…",
  "main.leaveSignal": "Оставить сигнал",
  "main.share": "Поделиться",
  "signalSelection.chooseType": "Выберите тип сигнала",
  "signalSelection.category.attention": "Личные",
  "signalSelection.category.road": "Дорожные",
  "signalSelection.category.urgent": "Срочные",
  "signalSelection.chooseSignal": "Выберите сигнал",
  "signalSelection.suggestOwn": "Предложить свой вариант",
  "signalConfirmation.title": "Подтверждение сигнала",
  "signalConfirmation.plateHeading": "Проверьте номер автомобиля",
  "signalConfirmation.signalHeading": "Проверьте выбранный сигнал",
  "signalConfirmation.replyTitle": "Разрешить ответ в Telegram",
  "signalConfirmation.replyBody": "Включите эту функцию, чтобы владелец номера мог\nнаписать вам в Telegram. Ответ возможен только при\nналичии у вас @username. Решение отвечать остаётся\nза владельцем номера.",
  "signalConfirmation.consentText": "Подтверждаю, что сигнал соответствует\nреальной ситуации и не является спамом\nили ложным сообщением.",
  "signalConfirmation.warning": "После отправки изменить сигнал\nбудет невозможно",
  "signalConfirmation.sending": "Отправляем…",
  "signalConfirmation.send": "Отправить",
  "partner.loadingAria": "Загрузка",
  "partner.title": "Партнёрская программа",
  "partner.offerLine1": "Получайте бессрочно 30% со всех платежей",
  "partner.offerLine2": "приглашённых пользователей в BeepApp",
  "partner.offerLine3": "через affiliate-программу Telegram",
  "partner.connectUnavailable": "Подключение станет доступно после настройки Telegram Affiliate программы.",
  "partner.connectTelegram": "Подключиться в Telegram",
  "partner.qrAria": "QR-код партнёрской ссылки",
  "partner.download": "Скачать",
  "partner.promoHeading": "Создайте персональный промокод",
  "partner.promoHelperLine1": "Промокод активирует дополнительный год подписки",
  "partner.promoHelperLine2": "и помогает привлекать пользователей",
  "partner.promoAria": "Промокод",
  "partner.affiliateHeading": "Ваша affiliate-ссылка",
  "partner.affiliateHelper": "Сохраните ссылку, чтобы создать персональный QR-код",
  "partner.affiliateAria": "Affiliate-ссылка",
  "partner.qrNoteLine1": "QR-код можно размещать на автомобиле,",
  "partner.qrNoteLine2": "в социальных сетях и рекламных материалах",
  "partner.save": "Сохранить",
  "partner.reset": "Сброс",
  "partner.resetConfirm": "Сбросить сохранённую affiliate-ссылку? Промокод останется за вами.",
  "partner.promoFormatError": "Промокод должен содержать от 4 до 15 символов.",
  "partner.affiliateHostError": "Допустимы только ссылки t.me или telegram.me.",
  "partner.affiliatePathError": "В ссылке отсутствует Telegram-путь.",
  "partner.affiliateFormatError": "Некорректная affiliate-ссылка.",
  "partner.loadError": "Ошибка загрузки",
  "partner.checkInputError": "Проверьте введённые данные",
  "garageActivation.promoInvalid": "Промокод недействителен",
  "garageActivation.plateOccupied": "Этот госномер уже привязан",
  "garageActivation.activateError": "Не удалось активировать Гараж",
  "garageEntry.loadJournalError": "Ошибка загрузки журнала",
  "garageEntry.loadStatusesError": "Ошибка загрузки статусов",
  "garageEntry.activationSuccess": "Гараж успешно активирован",
  "garageEntry.plateAttached": "Номер привязан",
  "garageEntry.attachError": "Не удалось привязать номер",
  "garageEntry.activationNote": "Активируйте ваш гараж",
  "garageSheet.activationTitle": "Активация гаража",
  "garageSheet.plateHelper": "Введите госномер автомобиля",
  "garageSheet.promoHelper": "У вас есть промокод?",
  "garageSheet.cleanBonusLine1": "После активации у вас будет 1 час",
  "garageSheet.cleanBonusLine2": "на бесплатный «Чистый старт»",
  "garageSheet.activationFor": "Активация на",
  "garageSheet.cost": "Стоимость",
  "garageSheet.ownerConsentLine1": "Подтверждаю, что являюсь владельцем",
  "garageSheet.ownerConsentLine2": "транспортного средства с указанным",
  "garageSheet.ownerConsentLine3": "регистрационным номером.",
  "garageSheet.processing": "Выполняется...",
  "garageSheet.attach": "Привязать",
  "garageSheet.pay": "Оплатить",
  "garageLifecycle.cleanTitle": "Чистый старт",
  "garageLifecycle.deactivateTitle": "Деактивация Гаража",
  "garageLifecycle.cleanWarningLine1": "История номера будет удалена",
  "garageLifecycle.cleanWarningLine2": "без возможности восстановления!",
  "garageLifecycle.deactivateWarningLine1": "После деактивации доступ к функциям",
  "garageLifecycle.deactivateWarningLine2": "активного «Гаража» будет прекращён",
  "garageLifecycle.willBeDeleted": "БУДЕТ УДАЛЕНО",
  "garageLifecycle.cleanRemovedLine1": "• Все записи из «Бортового журнала»",
  "garageLifecycle.cleanRemovedLine2": "• История полученных сигналов",
  "garageLifecycle.cleanRemovedLine3": "• Публичные счётчики сигналов",
  "garageLifecycle.cleanRemovedLine4": "  на карточке номера",
  "garageLifecycle.willRemain": "СОХРАНИТСЯ",
  "garageLifecycle.cleanPreservedLine1": "• Привязка номера к «Гаражу»",
  "garageLifecycle.cleanPreservedLine2": "• Оставшийся срок активации",
  "garageLifecycle.cleanPreservedLine3": "• Выбранный статус номера",
  "garageLifecycle.cleanPreservedLine4": "• Общее количество просмотров карточки",
  "garageLifecycle.freeFirstHour": "Бесплатно в первый час",
  "garageLifecycle.willBecomeUnavailable": "СТАНЕТ НЕДОСТУПНО",
  "garageLifecycle.deactivateRemovedLine1": "• «Бортовой журнал»",
  "garageLifecycle.deactivateRemovedLine2": "• Выбор и использование статуса номера",
  "garageLifecycle.deactivateRemovedLine3": "• Автоматически покинете «Автоклан»",
  "garageLifecycle.deactivateRemovedLine4": "• «Автоторг»",
  "garageLifecycle.deactivateRemovedLine5": "• «Страховка»",
  "garageLifecycle.deactivateRemovedLine6": "• «Пит-стоп»",
  "garageLifecycle.deactivateRemovedLine7": "• «Техпомощь»",
  "garageLifecycle.deactivateRemovedLine8": "• Госномер будет отвязан от «Гаража»",
  "garageLifecycle.willRemainAvailable": "ОСТАНУТСЯ ДОСТУПНЫ",
  "garageLifecycle.deactivatePreservedLine1": "• «Попутчик»",
  "garageLifecycle.deactivatePreservedLine2": "• «Диспетчер»",
  "garageLifecycle.deactivatePreservedLine3": "• Поиск по госномеру и просмотр",
  "garageLifecycle.deactivatePreservedLine4": "  публичной карточки автомобиля",
  "garageLifecycle.deactivatePreservedLine5": "• Возможность в любое время",
  "garageLifecycle.deactivatePreservedLine6": "  снова активировать «Гараж»",
  "garageLifecycle.cleanConsentLine1": "Подтверждаю согласие на удаление",
  "garageLifecycle.cleanConsentLine2": "всей истории данного номера",
  "garageLifecycle.cleanConsentLine3": "без возможности восстановления.",
  "garageLifecycle.deactivateConsentLine1": "Подтверждаю деактивацию и",
  "garageLifecycle.deactivateConsentLine2": "прекращение доступа ко всем",
  "garageLifecycle.deactivateConsentLine3": "функциям активного «Гаража».",
  "garageLifecycle.clean": "Очистить",
  "garageLifecycle.deactivate": "Деактивировать",
} as const

export type MessageKey = keyof typeof ruMessages
